import React from 'react';

function Candidate({ candidateData }) {
    if (!candidateData) {
        return null; // Or a loading indicator if you prefer
    }

    const c_img = `${process.env.PUBLIC_URL}/assets/candidates/${candidateData.Cand_Name_English?.replaceAll(" ", "-") || 'placeholder'}.jpg`; // Placeholder image handling
    const party_css = `k_party ${candidateData.Party?.toLowerCase()}`;
    let l_stat = candidateData.Status?.trim().toUpperCase();
    l_stat += (candidateData.Lead_Trail) > 0 ? " BY " : "";
    if (candidateData.Lead_Trail > 0) {
        l_stat += `<span>${candidateData.Lead_Trail}</span>`;
    } else {
        l_stat += `<span>${candidateData.Lead_Trail}</span>`;
    }

    const l_img = (() => {
        const status = candidateData.Status?.trim().toLowerCase();
        if (status === "lead" || status === "leading" || status === "won" || status === "margin") {
            return <img src={`${process.env.PUBLIC_URL}/assets/lead_r.png`} alt="" className="lt-img" />;
        } else if (status === "trail" || status === "trailing" || status === "lost") {
            return <img src={`${process.env.PUBLIC_URL}/assets/trail_r.png`} alt="" className="lt-img" />;
        }
        return null;
    })();


    return (
        <div className="candidate cardBorder">
            <div className="c-image">
                <img className="c-img"
                    src={c_img}
                    alt={candidateData.Cand_Name_English || "Candidate Image"}
                    onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = `${process.env.PUBLIC_URL}/assets/placeholder.jpg`;
                    }}
                />
                {l_img}
            </div>
            <div className="c-details">
                <div className="c-detail-1">
                    <h4 className="kc-name">{candidateData.Cand_Name_English}</h4>
                    <div className="c-detail-1-in">
                        <span className="constituency">{candidateData.Constituency}</span>
                        <span className={party_css}>{candidateData.Party}</span>
                    </div>
                </div>
                <div className={`c-detail-2 ${candidateData.Status?.trim().toLowerCase()}`} dangerouslySetInnerHTML={{ __html: l_stat }}>
                </div>
            </div>
        </div>
    );
}

export default Candidate;